export default __webpack_public_path__ + "21c9f68e4b9e0ca8fd6b5b02b64a25ba.png";